import { render } from "./SalesQuotesMonthListPage.vue?vue&type=template&id=8c57af4a&scoped=true&ts=true"
import script from "./SalesQuotesMonthListPage.vue?vue&type=script&lang=ts"
export * from "./SalesQuotesMonthListPage.vue?vue&type=script&lang=ts"

import "./SalesQuotesMonthListPage.vue?vue&type=style&index=0&id=8c57af4a&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c57af4a"]])

export default __exports__